export interface DigitalFilingActivityCreateRequestModel {
  name: string;
}
